import { useEffect } from 'react';
// Locks page (body) scrolling while `active` is true, so a modal taller than the
// viewport scrolls inside itself and the background never moves. Ref-counted at the
// module level so nested/overlapping modals don't restore the scroll too early.
let lockCount = 0;
let savedOverflow = '';
export function useBodyScrollLock(active) {
    useEffect(() => {
        if (!active)
            return;
        if (lockCount === 0) {
            savedOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
        lockCount += 1;
        return () => {
            lockCount -= 1;
            if (lockCount === 0)
                document.body.style.overflow = savedOverflow;
        };
    }, [active]);
}
